export const primaryWebsiteFieldConfig = {
  key: 'canonical_website',
  settings: {
    requiredSave: true,
    requiredPublish: true,
  },
}

// Override properties that are critical to application stability with fallback values
export const overrideComposerSettings = {
  disabledDraftPlugins: {
    scroll: false,
    typograph: false,
  },
  disableWebskedIntegration: true,
}

// Minimum settings required to use Composer when settings has not yet been saved
export const defaultComposerSettings = {
  pageBuilderPrvURL: '',
  tools: [
    'text',
    'header',
    'image',
    'reference',
    'gallery',
    'video',
    'raw_html',
  ],
  ansOverrides: {},
  locking: {},
  siteServiceBasePaths: [],
  tags: [],
  metas: [],
  timePickers: {},
  lineSettings: {
    default: {
      unit: 'words',
      value: 33,
      linesPerInch: 7,
    },
    websites: {},
  },
  disableWebskedIntegration: true,
  featuredMedia: {
    basic: {
      types: ['image'],
      label: 'Basic',
      requiredToPublish: false,
    },
  },
  circulations: {
    requiredToSave: false,
    omitWhenCloning: false,
  },
  disabledDraftPlugins: {
    typograph: false,
    scroll: false,
  },
  v2: {
    metas: [
      {
        key: 'language',
        settings: {},
      },
      {
        key: 'created_date',
        settings: {},
      },
      {
        key: 'first_publish_date',
        settings: {},
      },
      {
        key: 'display_date',
        settings: {},
      },
      {
        key: 'last_updated_date',
        settings: {},
      },
      {
        key: 'copyright',
        settings: {},
      },
      {
        key: 'location',
        settings: {},
      },
      {
        key: 'canonical_url',
        settings: {},
      },
      {
        key: 'source_system',
        settings: {},
      },
      {
        key: 'story_tags',
        settings: { requiredPublish: false },
      },
      {
        key: 'source_type',
        settings: {},
      },
    ],
    planning: [
      primaryWebsiteFieldConfig,
      {
        key: 'working_headline',
        settings: {
          requiredSave: true,
          requiredPublish: true,
        },
      },
      {
        key: 'section',
        settings: {
          requiredSave: false,
          requiredPublish: true,
        },
      },
      {
        key: 'description',
        settings: {},
      },
      {
        key: 'author_selection',
        settings: {
          requiredSave: false,
          requiredPublish: false,
        },
      },
      {
        key: 'schedule_planning',
        settings: {},
      },
      {
        key: 'media_planning',
        settings: {},
      },
      {
        key: 'planned_word_count',
        settings: {},
      },
    ],
  },
}
